
import {INIT_STATE_LOG} from "../../reducers/vehicleReducer";


export const initStateLog = (error) =>{
    return {
        type: INIT_STATE_LOG,
        payload: {}
    }
}